import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type CreateOnboardingProcessStepDto = ClientInferRequest<
  typeof contract.onboardingProcessSteps.create
>["body"];

export type CreateOnboardingProcessStepResponse = ClientInferResponseBody<
  typeof contract.onboardingProcessSteps.create,
  201
>;

export const createOnboardingProcessStepApi = async (
  body: CreateOnboardingProcessStepDto,
): Promise<CreateOnboardingProcessStepResponse> => {
  const response = await api.onboardingProcessSteps.create.mutation({ body });

  if (response.status === 201) {
    return response.body;
  }

  throw new ApiError("Failed to create onboarding process step", response.status, response.body);
};
